import store from '@/store';

/**
 * check if the specific key is in object.
 * @param {object} obj
 * @param {string} key - key name.
 * @return {boolean} - key 值是否存在於物件中。
*/
export function isObjKeyExist (obj = {}, key = '') {
  if (Object.keys(obj).length === 0 || key === '') {
    return false;
  }

  try {
    const isExist = Object.prototype.hasOwnProperty.call(obj, key);

    return isExist;
  } catch (e) {
    alert(e.message);
  }
}

/**
 * check the type of parameter.
 * @param variable - 欲檢查的變數。
 * @return {string} variable type(String、Number、Boolean、Undefined、Null、Function、Date、Array、RegExp、Error)
*/
export function getParamType (variable) {
  const result = Object.prototype.toString.call(variable);
  const regex = new RegExp(/^\[object ([^\]]+)\]$/, 'gm');

  if (regex.test(result)) {
    return result.replace(regex, '$1');
  }

  return '';
}

/**
 * check if the variable is JSON.
 * @param {string} param - 欲檢查的變數。
 * @return {boolean} if the variable is json.
*/
export function isJSON (param) {
  if (!getParamType(param)) return false;

  try {
    JSON.parse(param);
  } catch (e) {
    return false;
  }

  return true;
}

/**
 * show dialog content according to object definition.
 * @param {object} dialogSetting - 對應 state.dialogItem
 * @param {string} actionType - dialog 按鈕點擊動作
*/
export function msgDialogControl (dialogSetting = {}, modalName = 'AppDialog', actionType = 'confirm') {
  store.commit('OPEN_DIALOG', { dialogSetting, type: actionType, modalName: modalName });
}

export function eventDebounce (func, delay = 180) {
  let timer = null;

  return () => {
    const context = this;
    const args = arguments;

    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
